import { TableHead } from '@sea-snag/ui';
import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react';

import type { SortState } from '../lib/table-sort';

/**
 * A column header that sorts server-side. Sorting has to happen in the database:
 * these tables page 20 rows at a time out of ~12k, so reordering the page in the
 * browser would answer a different question than the one being asked.
 */
export function SortableTableHead({
  column,
  sort,
  onSort,
  className,
  children,
}: {
  column: string;
  sort: SortState;
  onSort: (column: string) => void;
  className?: string;
  children: React.ReactNode;
}) {
  const active = sort.by === column;
  const Icon = !active ? ChevronsUpDown : sort.order === 'asc' ? ArrowUp : ArrowDown;

  return (
    <TableHead className={className} aria-sort={active ? `${sort.order}ending` : 'none'}>
      <button
        type="button"
        onClick={() => onSort(column)}
        className="-mx-1 inline-flex items-center gap-1 rounded px-1 py-0.5 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      >
        {children}
        <Icon
          className={`size-3 shrink-0 ${active ? 'text-foreground' : 'text-muted-foreground/50'}`}
          aria-hidden
        />
      </button>
    </TableHead>
  );
}
